import React, {useState, useEffect} from "react";

export default function TrendGiletFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);
  const [darkenColorContrast, setDarkenColorContrast] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -50));
    setDarkenColorContrast(adjust(darkContrast, -100));
  }, [lightContrast, darkContrast]);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M371.9578552,427.7686768c-0.4660034-3.3213501-0.8916016-5.293396-1.2974243-6.0303345
		c-1.0991821-1.9720459-1.2651978-10.7114258-1.2651978-10.7840576c0.0092773-0.7991943,1.0586548-79.961792,0-91.8356934
		c-0.9133911-10.1405029-0.281311-56.7849121-0.0622559-70.8384399c0.0404053-2.418335-0.7483521-4.805603-2.222229-6.7049561
		c-4.2866821-5.5632935-7.3578491-12.050354-9.6931763-20.4056396c-2.1080322-7.5353394-1.9928589-15.7037964-1.8682861-23.612793
		l0.0093384-1.1313477c0.2086182-14.2102661,1.6824951-28.3457642,3.1044312-40.3130493l0.0830688-0.6954346
		c1.4520264-12.2267456,2.9476929-24.8686523,6.6115723-36.9605103c0.8615112-2.8543091,1.5257568-6.3728638-0.8095703-8.5836792
		l0.0415039-0.0622559c-5.8123779-3.87146-16.4303589-10.7736816-22.2126465-13.5345459
		c-7.8571167-3.7468872-16.097229-6.7880249-24.5043945-9.0507202c-6.6634521-1.7966309-13.4411621-3.362854-20.1357422-4.6810303
		c-0.5604858-0.1038208-0.975647-0.1868286-1.3295898-0.2594604c-0.7566528-0.1557007-1.2860107-0.2698975-2.3872681-0.4463501
		l0.1349487-0.3425293c0.7369385-1.8059692,0.0415039-3.6752319-0.5698242-5.3245239
		c-0.0933838-0.2283936-0.1764526-0.467041-0.2698364-0.7058105l-8.9884644-21.6511192
		c-1.4125977-3.394043-4.2451172-5.8538818-7.5768433-6.5908203c-4.7858887-1.0596924-9.923584-1.2558594-14.8848877-1.453064
		c-1.151062-0.0519409-2.2927856-0.0934448-3.4137573-0.1453247c-6.3323975-0.3217773-12.7571411-0.4463501-19.078125-0.3840332
		c-8.8327026,0.0933838-17.9654541,0.1764526-27.0057373,1.5050049c-0.9133911,0.1348877-1.8164063,0.2791748-2.720459,0.4254761
		l-0.7991943,0.1246338c-1.9710083,0.3113403-3.7458496,1.3492432-5.0235596,2.9891968L190.269989,76.1298218
		c-1.1002197,1.4011841-1.432312,3.2071533-0.9455566,4.8782349c-4.8886108,1.1624756-11.5199585,2.895813-17.9239502,4.7017822
		c-5.9898682,1.6814575-12.0087891,3.5186157-17.8938599,5.4595337l-1.1832275,0.3840332
		c-3.7261353,1.2247314-7.5778809,2.4909668-11.2407227,4.0478516c-3.5808105,1.5257568-7.3184204,3.4563599-11.4275513,5.9265747
		c-2.0551147,1.2247925-4.2139893,2.5948486-6.093689,4.3167725l-0.4763794,0.4265747
		c-1.744751,1.5776367-4.1517334,3.7468872-4.348938,6.0303345c-0.1255493,1.3700562,0.3103638,2.6674805,0.7265625,3.9129639
		c0.1131592,0.3321533,0.2179565,0.6539307,0.3207397,0.9860229c3.3223877,10.9594727,5.6670532,22.8447876,7.4003906,37.3861084
		c1.4125977,11.9569092,2.895813,26.0934448,3.0940552,40.3130493l0.0197144,1.1209717
		c0.1152344,7.9078979,0.2397461,16.0774536-1.8682251,23.612793c-2.3353271,8.3656616-5.4169922,14.8527222-9.6932373,20.4056396
		c-1.4738159,1.90979-2.2636719,4.2969971-2.2211304,6.7153931c0.2169189,14.0430908,0.8500366,60.6459961-0.0633545,70.8383789
		c-1.0679932,11.8739014-0.0092773,91.036499,0,91.8253174c0,0.0830688-0.1660156,8.8120117-1.2651978,10.7944336
		c-0.4047852,0.7369385-0.8303223,2.7089844-1.2974243,6.0303345c-0.5407104,3.8195801,0.673645,8.1373291,3.3213501,11.8209229
		c2.105957,2.9384155,5.8632813,4.7132568,9.1846313,6.2908936c0.6538696,0.3010254,1.2974243,0.6123657,1.9004517,0.9133911
		c21.7331543,10.7944336,46.2385254,13.8251343,69.4777222,16.0048218c2.0353394,0.1868286,4.0582886,0.3736572,6.0936279,0.5604858
		c5.6463623,0.5085449,11.4888306,1.0482788,17.2296143,1.6813965l5.3556519,0.5812378
		c0.1349487,0.020752,3.0411377,0.3632813,4.8253174,0.3632813c0.1349487,0,0.2595215-0.0114136,0.3746948-0.0114136
		c1.2040405,0.5303955,6.6002197,0.8936768,12.1956177,0.8936768c4.7215576,0,9.5686646-0.2595215,12.1437988-0.9030151
		l0.1348877-0.0415039l0.0726929-0.1141968c0.0206909-0.0518799,0.0404663-0.0944214,0.0622559-0.1452637
		c1.2236938-0.0830688,4.991394-0.7888794,5.1376953-0.8200073l33.9505615-3.6431274
		c2.9892578-0.3217163,6.0615234-0.6019897,9.0299683-0.8614502c7.8249512-0.6954346,15.9217529-1.4115601,23.7166138-3.1345215
		c4.1412964-0.9133911,9.0714722-2.0758667,14.2611084-3.7988281c7.1502686-1.6087646,14.0316772-4.836731,20.0932007-7.69104
		c0.7680664-0.3529053,1.5049438-0.7057495,2.2325439-1.0379028
		C368.6676331,441.3032227,372.7996521,433.8405762,371.9578552,427.7686768z"
        />
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M252.3665771,96.3171463c-0.2916565-0.0207443-0.5822754-0.0300903-0.9341431-0.0414886
		c-1.338913-0.0311356-2.6778564-0.0830536-4.017807-0.1453247c-0.5916138-0.0197067-1.20401-0.0414963-1.8059845-0.0622787
		c-0.0415344-0.3217545-0.0934296-1.05867,0.0415039-1.8568497c0.0737-0.4888687,0.1567383-0.6953888,0.1972198-0.7898483
		c0.0425415,0.020752,0.0622711,0.0518875,0.103775,0.0518875C247.8090363,93.815773,250.0198212,94.8651047,252.3665771,96.3171463
		"
        />
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M240.0046692,95.964447h-0.1660767c-1.7758789,0.0207825-4.4111786,0.1463699-6.7164154,0.3632813
		c2.4495087-1.5143127,4.7339783-2.5948105,6.6437531-2.8854294c0.0415344,0.1037979,0.1131439,0.3113937,0.1961823,0.7690964
		C240.0762787,94.9369125,240.0451355,95.6012039,240.0046692,95.964447"
        />
        <path
          fill="#F0EFEF"
          d="M356.2098389,168.9202728c-0.0404968,0.4878235-0.0934448,0.9652863-0.1453247,1.4634705
		c-9.620575-1.4416504-53.6607666-7.5041809-100.2314606-5.8227539l-0.0425568-1.503952
		C302.4348755,161.3538055,347.0656738,167.5502319,356.2098389,168.9202728"
        />
        <path
          fill="#F0EFEF"
          d="M228.5348816,164.5922241c-43.6759338-1.6191559-83.8229065,3.4459229-99.3596039,5.7605133
		c-0.0425568-0.5085754-0.0840759-1.0171814-0.1349335-1.5153656c15.5367126-2.3041992,55.8186035-7.380722,99.4540558-5.7501221
		C228.5047607,163.5854645,228.5244904,164.0836487,228.5348816,164.5922241"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M211.4191589,327.4219055v29.1138306c0,0.1349487-0.0508728,0.259491-0.1453247,0.3539429
		c-0.1027527,0.0923767-0.2376709,0.1442566-0.373642,0.1442566c-33.9806519-0.8303223-56.9914703-2.1900024-68.3982697-4.036499
		c-4.0800934-0.6549072-7.7429352-2.0758362-11.0964661-3.5195923c-1.4738617-0.6227417-2.3550568-1.0067749-3.9949875-1.9824219
		c-0.2698517-0.1660767-0.4359207-0.4566956-0.4359207-0.7680969v-28.3457336c0-0.0519104,0.030098-0.0830383,0.0415192-0.0934143
		c0.020752-0.010376,0.0415115-0.0311279,0.0830307-0.0311279h0.019722l5.0131836,0.8926086
		c0.0736847,0.010376,7.6297913,1.6502991,11.5842896,2.2937927c0.622757,0.1038208,1.2973938,0.2179871,2.0332947,0.3331909
		c8.8742676,1.4831848,25.3990784,4.2544556,65.2761841,5.2404785
		C211.242691,327.0274963,211.4191589,327.203949,211.4191589,327.4219055"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M216.8582153,193.6753998c0,0.1546783-0.0726624,0.259491-0.1349487,0.3311005
		c-0.1027527,0.1152344-0.2698669,0.1878662-0.4463043,0.1878662l-75.6751709,1.5454865
		c-0.2906189,0-0.5500946-0.196167-0.5604706-0.4670715l-1.1002045-25.5952301
		c17.0022583-2.179657,45.4517975-5.0121613,76.9206848-4.7111511L216.8582153,193.6753998z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M345.2082214,169.5842438l-0.6020203,25.2942657c0,0.2708893-0.259491,0.4878387-0.5604858,0.4878387
		h-0.0103455l-75.5921631-0.2802734c-0.1660767,0-0.3310852-0.0612183-0.4359131-0.1764221
		c-0.0934143-0.092392-0.1453247-0.2075958-0.1453247-0.3321381l0.1349487-29.6224213
		C299.8819885,164.6655273,329.1836548,167.5914307,345.2082214,169.5842438"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M358.9809875,318.3815918v28.3457642c0,0.3113708-0.1650696,0.6019897-0.4463501,0.7680664
		c-1.6295166,0.975647-2.5210876,1.3596802-3.9949646,1.9824219c-3.3431396,1.4437561-7.006012,2.8646851-11.0954285,3.5196228
		c-11.3964233,1.8464661-34.4072266,3.2061462-68.388916,4.0364685c-0.1245422,0-0.2698669-0.0518799-0.3736572-0.1442566
		c-0.0944519-0.0944519-0.1557007-0.2189941-0.1557007-0.3539429v-29.1138c0-0.2179871,0.1868286-0.3944397,0.4048157-0.4047852
		c39.8760376-0.9860535,56.3998413-3.7572937,65.2740784-5.240509c0.7379761-0.1152039,1.4126587-0.2293701,2.0353699-0.3331604
		c3.9545288-0.6435242,11.5002441-2.2834473,11.5625-2.2938232l5.0329285-0.8926086h0.0217896
		c0.0415039,0,0.0612183,0.020752,0.0830383,0.0311279C358.9508667,318.2985535,358.9809875,318.3297119,358.9809875,318.3815918"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M255.3140717,463.8158569c-5.8850403,1.4012146-22.3153992,0.8303528-23.8006744,0
		c-1.4416809-0.7991943-1.0379181-3.4043884-1.0379181-3.4562988c0.509613-5.4387207,1.0379181-58.8192444,0.8614655-67.6312256
		c-0.0830231-4.2036133-0.3207092-42.6380005-0.5802002-83.335083
		c-0.2906189-44.6307983-0.6123657-95.2089233-0.7888336-112.0544434
		c-0.0622711-5.2415466-0.1556854-10.6283875-0.2802277-16.4926605
		c-0.3010101-13.1712799-0.8303375-26.5501251-1.3295898-39.4930573l-0.2376862-6.1040649
		c-0.4369507-11.0736313-0.3746796-21.1830215-0.3009949-31.8944244l0.0197144-3.3005905
		c1.360733-1.0586777,2.7100372-2.0343246,4.0167694-2.9165726c2.5335999-0.3010101,5.8653259-0.4670792,7.9930725-0.4982147
		h0.3622437c0.35289-0.0103607,0.7057953-0.0103607,1.0597076-0.0103607
		c2.0343475,0.0103607,4.110199,0.1037674,6.1123657,0.1764297c1.3503265,0.0622787,2.6882172,0.1141891,4.0385742,0.1453247
		c0.8303223,0.020752,1.275589,0.0414963,2.1993561,0.1660767c0.0218048,0.0103531,0.0311279,0.0207443,0.0425415,0.0311356
		c0,0.1972046,0,0.7680511,0.0508728,2.3456879c0.1359711,3.4355316,0.1255798,10.0668488,0.1255798,14.0431366v1.3181839
		c0.0508728,2.698616,0.1038055,5.3972015,0.1650391,8.0958099c0.0321655,1.5361404,0.0737,2.3249435,0.1048279,3.1241684
		c0.0404816,0.7680588,0.0726471,1.5465012,0.1027527,3.0099792c0.0840759,3.2071838,0.1567383,6.4040222,0.2397614,9.6008148
		c0.0830383,3.2798462,0.1660614,6.5493011,0.259491,9.8187714l0.4463043,16.0774841h-0.0207672l0.0207672,0.6746521h0.0197144
		l0.7680664,27.8060455l-0.1027527,266.7676697C255.8434143,459.8509827,256.2990723,462.0410156,255.3140717,463.8158569"
        />
        <path
          fill={darkenColor}
          d="M267.5817566,73.3793945c-2.9996338,5.5529099-14.5724945,14.4168015-21.8276062,19.1497421
		c-0.093399,0.0518875-0.1556702,0.1349411-0.1971893,0.2283478l-0.0518951,0.0415268
		c-0.1660767,0.0934067-0.3632813,0.3311005-0.5189667,1.2974091c-0.1442719,0.8199387-0.1037903,1.5464935-0.0622711,1.9409103
		c-1.2143707-0.0415268-2.4391327-0.0726624-3.6535034-0.083046h-0.5802002
		c0.0301056-0.4058228,0.0612335-1.1012192-0.0633087-1.8578644c-0.1660767-0.9663086-0.3622284-1.2040024-0.5283051-1.2974091
		L240.06633,92.78862c-0.0311432-0.0518799-0.0612335-0.1037979-0.1141815-0.1452942
		c-7.0464783-4.5668945-18.1636963-13.0155945-21.7030182-18.682663
		C221.0411377,73.348259,237.2535553,70.2656174,267.5817566,73.3793945"
        />

        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
		136.2810059,325.0865784 135.2596893,323.5650024 135.009552,324.8374939 133.9000092,323.1861572 133.6291046,324.5655518 
		132.535141,322.9370422 132.2673492,324.2987976 131.2532959,322.7886353 131.0052338,324.0507507 129.9724884,322.5135803 
		129.7202759,323.7995605 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M129.7200775,322.9356995c0.2262573,0.0498047,9.4887238,2.0281067,13.493042,2.6757507l2.0229034,0.3331909
		c8.7787781,1.4676208,24.9901428,4.1776428,63.5760803,5.2145386"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M259.5529785,460.6939697c10.8348999-1.0908508,21.6729126-2.1619873,32.5067749-3.2652893
		c7.3173828-0.7452393,14.6358032-1.4915161,21.9376221-2.3695984c6.0023193-0.7203064,11.9610291-1.5475464,17.7931213-3.151123
		c6.6904907-1.8381958,13.5055237-3.9150696,19.9717712-6.624054c3.3058167-1.3856506,6.5441284-2.9425354,9.6578979-4.7194519
		c3.0857849-1.7603149,6.1102905-3.54245,7.7304993-6.8565369"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M259.2458496,443.4334717c40.5154114-4.0769653,60.6646729-5.738678,67.5232849-7.3557739
		c3.224823-0.7608032,9.0610962-1.5163879,12.2433472-2.4463806c21.2961731-6.2275696,25.4717712-12.2568665,28.831543-14.9928284"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M229.0851746,460.6939697c-39.9331512-4.0177917-60.4716339-5.9223938-68.1491699-7.7325439
		c-3.2269135-0.7618408-7.075531-1.7260742-10.1924286-2.8511658c-3.6026306-1.3015747-29.9265137-7.8685303-35.4233704-19.3054199"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M229.3923035,443.4334717c-40.5154419-4.0769653-60.6647034-5.738678-67.5222626-7.3557739
		c-3.2258759-0.7608032-9.0621338-1.5163879-12.2444153-2.4463806
		c-21.2961731-6.2275696-28.9467087-15.4474487-32.307518-18.1834106"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M257.2095337,166.1724548l0.7493591,26.9539337l-0.1172485,266.7490234l0.0114136,0.1162415l-0.0010681-0.0384216
		c0.0072937,0.1422119,0.0249329,0.2470398,0.0342712,0.3031006c0.0290527,0.1691589,0.122467,0.8157654,0.0166016,1.506012"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M255.7245789,99.3985214c-0.0529327,2.2253265-0.0062408,4.4454575,0.039444,6.5939713l0.0072632,0.362236
		c0.0342407,1.3617401,0.0767975,6.8959656,0.0767975,8.5026779c0.0311432,1.8703384,0.0705872,3.7002029,0.1089935,5.5311127
		l0.0539703,2.6062164l0.2335205,7.123291c0.0695496,2.8781891,0.1401367,5.7615204,0.2169495,8.6386566
		c0.0747375,3.1853943,0.1577454,6.3718414,0.2418213,9.5644836l0.2698669,9.9173737
		c0.0466919,1.8226166,0.0383911,1.498764,0.0882263,3.325531"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M254.4130707,462.0866699c-2.3031769,0.4286804-6.1206512,0.6705017-10.6854706,0.6705017
		c-6.0905457,0-10.8919678-0.4193115-11.6538239-0.721344c-0.1318207-0.0757751-0.172287-0.8594055-0.1079407-1.3171387
		l0.0176544-0.1349182c0.5158386-5.6079407,1.0482941-58.7123718,0.8697815-67.9031982
		c-0.0768127-4.1330261-0.3207245-41.8273621-0.5802155-81.7345886l-0.0768127-12.0326538
		c-0.2719269-42.3100281-0.5521698-86.0596466-0.7234192-101.6056976
		c-0.2999573-28.6996765-1.7592926-61.1940308-2.0966187-68.3972473l0.2532654-0.6331177l-0.2947693-0.5521851
		c-0.0965271-5.0640411-0.0259552-21.6480179,0.0020752-27.1511002h0.0114136l0.0062256,0.0965424v-1.4541321
		c0.4172363-0.0820084,0.8521423-0.1338882,1.2558899-0.1806107l0.455658-0.0622711
		c2.1184082-0.2615433,4.3395691-0.3944168,7.1865845-0.430748l0.3767853-0.0114059l1.0265045,0.0010452
		c1.8526764,0.0103607,3.7562408,0.0851135,5.5995941,0.1556854l0.4712372,0.0176392
		c1.3461761,0.0581284,2.704834,0.1152039,4.0551605,0.1452942l0.2044678,0.009346
		c0.5148163,0.0124817,1.0161285,0.02388,1.5164185,0.02388c0.2511749,0,0.5034027-0.0031052,0.7524872-0.0093384
		c0.0934143,0.6455994,0.0799255-0.6321106,0.0529327,0.2584305l-0.0041504,0.1401291"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M217.7247772,72.1753006c0,0,16.2528687-4.2118835,50.4058075-0.6414185"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M292.094635,78.5254364l-0.9714966,2.2834549c-3.2030334,7.8996429-10.3149109,25.4312668-15.0613403,31.8093109
		c-0.880188-0.7908936-1.9668884-1.8049622-3.2071838-2.9611969l-0.0913391-0.0861588
		c-6.0780945-5.6639557-14.7354431-13.7317657-21.8317413-17.2254257"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M234.6286316,92.348938c-7.0994263,3.4957504-15.7546692,11.5645981-21.8234253,17.2223206
		c-1.3264771,1.2361832-2.4474335,2.2772141-3.3369446,3.0764008c-4.7900238-5.9971161-14.4136658-25.4281311-18.9369507-34.9479904
		"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M129.1209869,166.9235077c14.6876831-2.1702728,55.7303772-7.3920898,99.6989899-5.7251892"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M355.5681763,166.9245453c-15.1381531-2.2377319-56.0573425-7.1928101-98.0279236-5.8237915"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M140.6608429,169.3085327l1.0233917,23.7778778c0.0218048,0.4992218,0.4380035,0.8894958,0.9372559,0.8791046l71.5213776-1.4686737
		c0.5117188-0.0103607,0.9175262-0.4380035,0.8988647-0.9507294l-0.925827-26.8635864"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M140.7662048,196.0796661l2.4048615,55.1771851c0.0404816,0.9403687,0.9040375,1.7084198,1.9263916,1.7146606l71.3013611,0.3954315
		c1.092926,0.0062408,1.9512939-0.7784424,1.9191132-1.7509613l-1.93573-57.0880127"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M269.7335815,164.6500397l-0.1224976,27.7396088c-0.0020752,0.530365,0.4266052,0.9621582,0.9569702,0.9642487
		l71.3916321,0.2687988c0.5231628,0.0020905,0.9518127-0.4151611,0.9642639-0.9382782l0.5490417-23.2775574"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M343.8844604,195.7057037l-1.3285828,55.9597778c-0.0227966,0.9528198-0.8790894,1.734375-1.9128723,1.7468567
		l-71.0553589,0.8137207c-1.0732117,0.0124512-1.9336548-0.7639008-1.9232788-1.7364502l0.6788025-57.0672302"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M277.0234375,358.8222046v71.7569885c2.953949-0.2916565,5.9068298-0.572937,8.8618164-0.8531799
		c10.9179382-1.0514221,22.2084961-2.1381226,33.2987366-3.4749756c6.693573-0.8064575,13.42453-1.8121948,20.0049744-2.9923401
		c3.1604919-0.5677185,6.0095825-1.1230164,8.8514404-2.1868896c2.5491333-0.9476318,4.9726868-2.1734314,7.2177124-3.6472778
		l0.4805603-66.4895325"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M280.4220276,358.6205139v68.2145691c1.7135925-0.1650391,3.4282532-0.3290405,5.1418762-0.4919739
		c10.8816223-1.0472717,22.1369019-2.1298218,33.213623-3.4656372c6.6333923-0.7971191,13.2989502-1.7945862,19.8119202-2.9622498
		c2.9954834-0.5386658,5.6836853-1.0617981,8.2598267-2.0249939c1.7489014-0.6507568,3.4324341-1.4437561,5.0266724-2.3685303
		l0.4276123-63.0342712"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M276.3726807,327.6803589l0.2781372,27.3929443c33.0953064-0.8365479,55.5279846-2.1723633,66.6815491-3.9752502
		c3.8745728-0.625885,7.4045715-1.9980164,10.6439209-3.3867493c1.2808228-0.5501099,2.053009-0.8811951,3.2684326-1.5787048
		v-23.3367004v-3.4365845"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M356.2341003,322.9356995c-0.2262878,0.0498047-9.4887695,2.0281067-13.493042,2.6757507l-2.0229187,0.3331909
		c-8.7777405,1.4676208-24.9901428,4.1776428-63.5760803,5.2145386"
        />

        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
		349.6731567,325.0865784 350.694458,323.5650024 350.9445801,324.8374939 352.0541382,323.1861572 352.3250427,324.5655518 
		353.4190063,322.9370422 353.6867981,324.2987976 354.7018738,322.7886353 354.9489136,324.0507507 355.9816284,322.5135803 
		356.2338562,323.7995605 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M208.9308319,358.8222046v71.7569885c-2.9528961-0.2916565-5.9068451-0.572937-8.8618164-0.8531799
		c-10.9179382-1.0514221-22.2084961-2.1381226-33.2987366-3.4749756c-6.6925354-0.8064575-13.42453-1.8121948-20.0049896-2.9923401
		c-3.1604767-0.5677185-6.0095825-1.1230164-8.8514099-2.1868896c-2.5491486-0.9476318-4.972702-2.1734314-7.2177429-3.6472778
		l-0.4805603-66.4895325"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M205.5321503,358.6205139v68.2145691c-1.7136078-0.1650391-3.4282684-0.3290405-5.1418915-0.4919739
		c-10.8816071-1.0472717-22.1368713-2.1298218-33.213623-3.4656372c-6.6323395-0.7971191-13.2978973-1.7945862-19.8119202-2.9622498
		c-2.9944153-0.5386658-5.6836853-1.0617981-8.2598114-2.0249939c-1.7489014-0.6507568-3.4324188-1.4437561-5.0266876-2.3685303
		l-0.4276123-63.0342712"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M209.5815125,327.6803589l-0.2781677,27.3929443c-33.0952911-0.8365479-55.526947-2.1723633-66.6815338-3.9752502
		c-3.874588-0.625885-7.4045715-1.9980164-10.6428986-3.3867493c-1.2818298-0.5501099-2.0540619-0.8811951-3.2694702-1.5787048
		v-23.3367004v-3.4365845"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M134.5589905,164.2334137c-0.3394165-3.2320862-0.7078705-6.4621124-1.0898285-9.6879883
		c-1.514328-12.7498779-2.9684753-25.3731384-6.7081146-37.7203064c-0.4732971-1.5641403-1.0815201-3.1833038-1.6004791-4.8564377
		l-2.2055969-5.4366684"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M116.5604248,252.0901794c2.4733658-2.6134644,5.3297424-5.4148254,7.6775284-8.1310883
		c6.9842148-8.0761108,10.3958664-20.2675781,11.7773514-30.7693024c0.7991943-6.0625305,0.6414337-12.1966705,0.5552826-18.2955322
		c-0.1079407-7.6505585-0.5791626-15.2845154-1.2569275-22.9018402"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M349.713623,164.2334137c0.3404236-3.2320862,0.7078552-6.4621124,1.0908813-9.6879883
		c1.5132446-12.7498779,2.9684448-25.3731384,6.7070313-37.7203064c0.4733276-1.5641403,1.081543-3.1833038,1.6005249-4.8564377
		l1.2734985-3.4012985"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4670666"
          strokeMiterlimit="10"
          strokeDasharray="1.3939345,1.3928965"
          d="
		M367.7121277,252.0901794c-2.4734192-2.6134644-5.3297729-5.4148254-7.6775513-8.1310883
		c-6.9841919-8.0761108-10.3948364-20.2675781-11.7773438-30.7693024
		c-0.7981567-6.0625305-0.6414185-12.1966705-0.5552979-18.2955322c0.1079407-7.6505585,0.5791626-15.2845154,1.2569275-22.9018402"
        />
        <path
          fill="#010101"
          d="M371.5918579,427.7687073c-0.4660339-3.3213806-0.891571-5.2934265-1.2973938-6.030365
		c-1.0991821-1.9720459-1.2652283-10.7113953-1.2652283-10.7840576c0.0093079-0.7991943,1.0586548-79.961792,0-91.8356628
		c-0.9133911-10.1405334-0.281311-56.7849121-0.0622864-70.8384247c0.0404663-2.418396-0.7483521-4.805603-2.2221985-6.7050018
		c-4.2866516-5.5632935-7.3578491-12.0503235-9.6932068-20.4056244c-2.1080322-7.5353546-1.9928284-15.7038116-1.8682861-23.6128082
		l0.0093689-1.1313324c0.2086182-14.2102509,1.6824646-28.3457489,3.1044312-40.3130341l0.0830383-0.6954346
		c1.4520569-12.2267609,2.9477234-24.8686829,6.6115723-36.9605179c0.8615112-2.8542938,1.5257568-6.372879-0.8095703-8.5836716
		l0.0415344-0.0622711c-5.8124084-3.8714447-16.4303894-10.773674-22.2126465-13.5345306
		c-7.8571167-3.7469254-16.0971985-6.7880402-24.504425-9.0507126c-6.6634521-1.796669-13.4411011-3.3628998-20.1357422-4.6810532
		c-0.5604553-0.1037979-0.975647-0.186821-1.3295593-0.2594833c-0.7566528-0.1556854-1.2860107-0.2698746-2.3872375-0.4463043
		l0.1349182-0.3425293c0.7369385-1.8059845,0.0415344-3.6752777-0.5698242-5.3245621
		c-0.0934143-0.2283478-0.1764526-0.4670486-0.2698669-0.7057877l-8.9884338-21.6511154
		c-1.4125977-3.3940392-4.2451172-5.8539162-7.5768433-6.5908356c-4.7858887-1.0597191-9.9236145-1.2558823-14.8848877-1.4530907
		c-1.151062-0.0519142-2.2927856-0.0934105-3.4137573-0.1453247c-6.3323669-0.3217545-12.7571411-0.4463005-19.0780945-0.3840256
		c-8.8327484,0.0934067-17.9654694,0.1764603-27.0057983,1.5050049c-0.9133759,0.134903-1.8163605,0.2791824-2.7203979,0.4255219
		l-0.7992096,0.1245766c-1.9710236,0.3113632-3.7458649,1.3492928-5.0235596,2.9892006l-13.5542755,25.8443794
		c-1.1002045,1.4011765-1.4323273,3.2071838-0.9455566,4.8782349c-4.8886261,1.162468-11.519928,2.8958206-17.9239349,4.7017975
		c-5.9898682,1.6814346-12.0088043,3.5185852-17.8938446,5.4595032l-1.1832275,0.3840256
		c-3.7261505,1.2247467-7.5778961,2.4910126-11.2407532,4.047905c-3.5808411,1.5257492-7.3184052,3.4563141-11.4275513,5.9265823
		c-2.0550919,1.2247391-4.213974,2.5948105-6.0936661,4.3167267l-0.4764023,0.4265671
		c-1.7447586,1.5776672-4.1517105,3.7469254-4.3489151,6.0303497c-0.1255951,1.3700638,0.3103333,2.6674728,0.7265472,3.9129944
		c0.1131439,0.3321457,0.2179718,0.6539001,0.3207245,0.9860153c3.322403,10.9594727,5.6670761,22.8447571,7.4004135,37.3861084
		c1.4126129,11.9568939,2.895813,26.0934448,3.0940399,40.3130341l0.0197449,1.1209412
		c0.1151886,7.9079437,0.2397461,16.0774689-1.8682709,23.6128235c-2.3353424,8.3656769-5.4169464,14.8527069-9.6931992,20.4056244
		c-1.4738541,1.9097748-2.2637177,4.2969971-2.2211609,6.7153778c0.2169266,14.0431061,0.8500595,60.6460114-0.0633163,70.8384247
		c-1.0680161,11.8738708-0.0093307,91.0364685,0,91.8253174c0,0.0830383-0.1660614,8.8119812-1.2652283,10.7944336
		c-0.4047928,0.736908-0.8303452,2.7089844-1.2974091,6.0303345c-0.5407562,3.8195801,0.6736221,8.1373291,3.3213654,11.8209229
		c2.105957,2.938385,5.8632431,4.7132263,9.1846008,6.2908936c0.6539001,0.3009949,1.2974091,0.6123657,1.9004517,0.9133606
		c21.7331238,10.7944336,46.2385559,13.8251648,69.4777069,16.0048218c2.0353851,0.1868286,4.0583038,0.3736572,6.0936737,0.5604858
		c5.6463165,0.5085754,11.4888,1.0483093,17.2295532,1.681427l5.3556976,0.5812378
		c0.1349487,0.020752,3.0411377,0.3632813,4.8253326,0.3632813c0.1349335,0,0.2594757-0.0114136,0.3746796-0.0114136
		c1.2039948,0.530365,6.600174,0.8936462,12.1956329,0.8936462c4.7215271,0,9.5686493-0.259491,12.1437378-0.9029846
		l0.1349182-0.0415344l0.0726624-0.1141663c0.020752-0.0519104,0.0404816-0.0944519,0.0622711-0.1452942
		c1.2237091-0.0830383,4.9914093-0.7888489,5.1377411-0.8199768l33.9505615-3.6431274
		c2.9891968-0.3217468,6.0614624-0.6019897,9.0299377-0.8614807c7.8249207-0.6954041,15.9217834-1.4115601,23.7166138-3.1345215
		c4.1412964-0.9133911,9.0714417-2.0758667,14.2610779-3.7988281c7.1502686-1.6087646,14.0317383-4.836731,20.0932312-7.6910095
		c0.7680359-0.3529053,1.5049744-0.70578,2.2325745-1.0379333
		C368.3016357,441.3032532,372.4336243,433.8405762,371.5918579,427.7687073 M356.0644836,170.3838654
		c-9.6205444-1.4427338-53.6607666-7.5042114-100.2314453-5.8227692l-0.0425568-1.5049744
		c46.6443634-1.7022247,91.2751923,4.4942017,100.4193268,5.8642731
		C356.1693115,169.4082184,356.116394,169.8856506,356.0644836,170.3838654 M345.2077637,169.5846405l-0.6019592,25.2942505
		c0,0.2698822-0.259491,0.4867859-0.5605164,0.4867859h-0.010376l-75.5921021-0.2791901
		c-0.1660767,0-0.3311157-0.0622711-0.434906-0.1764526c-0.0934143-0.0934143-0.1452942-0.2075653-0.1452942-0.3321075
		l0.1349182-29.6224213C299.8815613,164.6648865,329.1832275,167.5918427,345.2077637,169.5846405 M295.906311,82.9386215
		c0.3529053,0.0716171,0.7784424,0.166069,1.3389282,0.2698364c6.6748962,1.3078003,13.4317932,2.8750763,20.0952759,4.6706696
		c8.3553162,2.2523117,16.5652771,5.2830658,24.3808899,9.0092163c5.6359253,2.6882248,15.9217834,9.3620834,21.7850037,13.254303
		l-0.010376,0.0103912c2.3457031,1.9409103,1.6824646,5.3453064,0.8521423,8.1061935
		c-3.6846313,12.1437225-5.1896362,24.8271637-6.6437683,37.0850677l-0.0830383,0.6850433
		c-0.456665,3.8704224-0.9133606,7.9712982-1.3388977,12.2164001c-9.2261353-1.3804626-53.8683472-7.5560913-100.5127411-5.8643036
		l-0.3840332-13.8988495c-0.0923767-3.2684174-0.1764526-6.5378876-0.2594757-9.807373
		c-0.0830383-3.1967926-0.1546631-6.4039764-0.2377014-9.6008148c-0.0311279-1.4842224-0.0726624-2.2626724-0.1048279-3.0307236
		c-0.0311279-0.7992249-0.0716095-1.5776672-0.1027527-3.1034164c-0.0622711-2.7089767-0.1152191-5.3972015-0.1660614-8.0958099
		v-1.3078003c0-3.9762878,0-10.6179581-0.1255951-14.0742722c-0.0300903-0.9445114-0.0415192-1.515358-0.0508575-1.8578644
		c5.7698212,3.9648514,12.1125946,9.8706512,16.5237885,13.9808655c2.2512512,2.106987,4.036499,3.7676392,5.0962219,4.5772247
		c0.2075806,0.1557159,0.4867554,0.1349335,0.6736145-0.0414963c4.9197388-4.6706696,12.7872314-23.8722916,16.7624817-33.639183
		C294.5788269,82.6687469,295.0863647,82.7725449,295.906311,82.9386215 M190.4644775,76.4930801l13.5656738-25.8443489
		c1.1313477-1.4530907,2.7494812-2.4090118,4.5565033-2.6882248l0.7992096-0.1245461
		c0.9019623-0.1453247,1.8049469-0.2916641,2.7079315-0.4255562c8.9988403-1.3181534,18.112854-1.4012032,26.9248505-1.4946136
		c6.3095398-0.0622749,12.7145844,0.0622711,19.035553,0.3736687c1.1209717,0.0622749,2.2616577,0.1037674,3.4147644,0.1556816
		c4.9394836,0.1972084,10.0367432,0.3944168,14.7697144,1.4427032c3.1241455,0.6850357,5.7708435,2.9996185,7.0993958,6.186058
		l8.9884338,21.6303749c0.0820007,0.2283401,0.1650391,0.4670486,0.259491,0.70578
		c0.6009521,1.6087723,1.214386,3.2694626,0.5812378,4.8367386l-0.1567383,0.3944168
		c-3.850708,9.4554901-11.8312988,29.0722809-16.7510986,33.8986588c-1.0379028-0.8199692-2.7712402-2.4297867-4.9405212-4.4527054
		c-6.7164001-6.2586975-17.874115-16.6597443-24.8801117-18.2052307
		c7.5145874-4.9415512,19.3583527-14.0846634,21.9729156-19.6063995c3.7987671-5.6982346,9.4046326-15.060318,9.8914185-17.3437691
		c0.3009949-1.3908157-0.020752-2.9061775-0.8396912-4.0593071c-0.6237793-0.8604507-1.8163757-1.929512-4.0582886-2.1889915
		l-0.0830383,0.6642876c1.5766296,0.1868172,2.8221436,0.8510742,3.591217,1.9201355
		c0.7047729,0.9849968,0.9860535,2.3353348,0.7369385,3.5185852c-0.4266052,1.9824409-5.5124207,10.6491318-9.6848755,16.9493179
		c-31.3869019-3.2590714-47.8172455,0.1037979-50.0591736,0.6123657c-0.0716095-0.1556778-0.1764374-0.3113632-0.2480621-0.4577026
		c-4.1734924-6.2576752-9.3631287-15.0904045-9.788681-17.103981c-0.2594757-1.1832504,0.0311432-2.5335884,0.7379761-3.5185852
		c0.7670135-1.0690613,2.0031891-1.7333183,3.5798035-1.9201355l-0.0726624-0.6642876
		c-2.2408752,0.2594795-3.44487,1.3285408-4.057251,2.1889915c-0.8303375,1.1531296-1.142746,2.6684914-0.8521271,4.0593071
		c0.4981995,2.2834511,6.0936584,11.6351738,9.8717041,17.291851c2.6456757,5.5840454,14.4053802,14.6762848,22.0029907,19.6583176
		c-2.1786194,0.4878235-4.7433167,1.8163681-7.4512787,3.6016006c-0.0736847,0.0103912-0.1349182,0.0197372-0.1982422,0.0311356
		l0.0114288,0.0934143c-5.9888458,3.9960175-12.6429749,10.1924362-17.2399597,14.4790802
		c-2.1692505,2.0135727-3.9036407,3.6327362-4.9519348,4.4527054c-5.728302-5.4802475-17.9758301-31.0755005-19.3677063-34.0128479
		C189.0933838,79.8871155,189.3123779,77.9773331,190.4644775,76.4930801 M244.9234009,96.0372391
		c-1.2143707-0.0415268-2.4380798-0.0726624-3.6524658-0.0830536h-0.5812225
		c0.0300903-0.4058228,0.0622711-1.1001968-0.0623016-1.8578644c-0.167099-0.9663086-0.3632507-1.2039948-0.5293274-1.2974091
		l-0.0311432-0.0103836c-0.0321808-0.0518875-0.0622711-0.1038055-0.1152191-0.1452942
		c-7.046463-4.5669022-18.163681-13.0156021-21.7030182-18.6826706c2.7930603-0.6124039,19.0054626-3.6950455,49.3326263-0.5812607
		c-2.9985962,5.5529022-14.5724945,14.4168015-21.8275909,19.1497421c-0.0934143,0.0518799-0.1546478,0.1349335-0.196167,0.2283401
		l-0.0518951,0.0415268c-0.1660614,0.0934143-0.3643188,0.3311005-0.5189514,1.2974091
		C244.8414154,94.9162598,244.8818817,95.6428223,244.9234009,96.0372391 M239.9621124,94.2104797
		c0.1141815,0.7265625,0.0830383,1.3908157,0.0425568,1.754097h-0.1660767
		c-1.7758789,0.0197296-4.4111786,0.1453247-6.7164001,0.362236c2.450531-1.5143204,4.733963-2.5948181,6.6437378-2.8843918
		C239.8074646,93.5462189,239.8790741,93.7537918,239.9621124,94.2104797 M239.8687134,93.3894958
		c0.0311279-0.009346,0.0726471-0.0197372,0.1048279-0.0404816l0.0103607,0.0404816
		C239.9413605,93.4112854,239.8998413,93.4008942,239.8687134,93.3894958 M245.7962952,93.3894958
		c-0.0529327,0.0217896-0.1037903,0.0217896-0.1764374,0l0.0300903-0.1027527
		C245.6925049,93.338623,245.7433624,93.359375,245.7962952,93.3894958 M245.6499481,94.2104797
		c0.0736847-0.4878311,0.156723-0.6953964,0.1972046-0.7888031c0.0425568,0.0207443,0.0622711,0.0508347,0.1048279,0.0508347
		c1.8578796,0.3435516,4.0676422,1.3918686,6.4143982,2.8449554c-0.2916718-0.0207443-0.5812531-0.0311356-0.9341431-0.0414963
		c-1.3389282-0.0321808-2.6778564-0.0830536-4.0167694-0.1453247c-0.5926666-0.0207443-1.20401-0.0415268-1.8070374-0.0633163
		C245.5669098,95.7466202,245.5160522,95.0097046,245.6499481,94.2104797 M127.4831238,154.5035858
		c-1.7333298-14.5838928-4.0904541-26.4982452-7.4222031-37.5012817c-0.1027527-0.3310928-0.2075806-0.6736298-0.3217545-1.0057373
		c-0.4141388-1.2351379-0.8085403-2.397644-0.6954117-3.6327438c0.176445-2.0250168,2.4609222-4.079071,4.1309433-5.5944366
		l0.4774475-0.4255524c1.8381653-1.6814346,3.9544983-3.0307236,5.9794922-4.2451096
		c4.0894318-2.4494934,7.7948151-4.3696594,11.3445282-5.8746643c3.6431274-1.5465012,7.4834442-2.8127747,11.1981812-4.0271606
		l1.1738892-0.3840256c5.8746643-1.940918,11.8832245-3.7676773,17.8730927-5.4595032
		c6.4247589-1.8059769,13.0882416-3.5496902,17.9768829-4.7121582c0.0311279,0.0622711,0.0415039,0.1245422,0.0716095,0.1764297
		c1.4126129,2.9788437,14.0016174,29.2695236,19.7309723,34.4176254l0.2086182,0.186821l0.2169342-0.1660461
		c1.0493317-0.7680817,2.8968506-2.4910431,5.2321777-4.6706619c3.4033508-3.1760864,7.9608917-7.421196,12.4955902-11.012413
		l-0.0103912,2.7816315c-0.0726471,10.7114029-0.1338806,20.8311844,0.3010101,31.9162292l0.2387238,6.1133881
		c0.2708893,6.9125977,0.5397186,13.9497375,0.7784424,21.0180054c-43.6437378-1.6088104-83.9162903,3.4562836-99.4851837,5.7604675
		C128.5106812,163.3986206,127.9917145,158.8110046,127.4831238,154.5035858 M129.0400085,168.8373413
		c15.5377655-2.3041992,55.818634-7.3806915,99.454071-5.7500916c0.010376,0.4981842,0.0300903,0.9963989,0.0404816,1.5049744
		c-43.6759186-1.6191559-83.8229065,3.4459229-99.3596039,5.7605133
		C129.1334229,169.8441315,129.0919189,169.335556,129.0400085,168.8373413 M215.8614807,164.9658966l0.9964142,28.7089996
		c0,0.1557159-0.0726624,0.2594757-0.1349335,0.3321381c-0.1027527,0.1141968-0.2688293,0.1868286-0.445282,0.1868286
		l-75.6751709,1.546524c-0.2916412,0-0.5511322-0.1972046-0.5615234-0.4670715l-1.1001892-25.5962677
		C155.9430542,167.4984436,184.3926086,164.6648865,215.8614807,164.9658966 M226.1587372,463.4318237l-5.3556976-0.5916138
		c-5.7397308-0.6331177-11.5936279-1.1635132-17.2399445-1.6824646c-2.0343475-0.185791-4.0582886-0.3726196-6.0926208-0.5594482
		c-23.1779327-2.169281-47.6107025-5.1896362-69.240036-15.9321594c-0.6123734-0.3113708-1.2558823-0.6123657-1.9097824-0.9237671
		c-3.2487106-1.5361328-6.922966-3.2798462-8.9272003-6.0614624c-2.5418854-3.5600891-3.7157745-7.69104-3.2071838-11.3549194
		c0.5604706-3.9752502,0.9766846-5.3349304,1.2247467-5.78125c1.1842804-2.1277466,1.3399582-10.7528992,1.3503342-11.1265564
		c-0.010376-0.7992249-1.0690613-79.9203186,0-91.763031c0.9133759-10.2235718,0.2698669-56.8679504,0.0612411-70.9121399
		c-0.0415115-2.2720184,0.6954117-4.5035553,2.0758514-6.2887878c4.3395691-5.6255341,7.4533463-12.1852417,9.8187943-20.6339722
		c2.1287689-7.6287231,2.0031891-15.8594971,1.8900604-23.8100128l-0.0207672-1.1209564
		c-0.1141663-8.1165771-0.6445618-16.1916504-1.3503418-23.8722839c2.4287415-0.3529053,5.4709015-0.7888031,9.0309906-1.2454987
		l1.0991669,25.5329437c0.0217896,0.6227722,0.5718842,1.1209869,1.2257843,1.1209869h0.0311432l75.6637573-1.5568848
		c0.35289-0.0103912,0.6954041-0.1557159,0.9351654-0.4048157c0.2075806-0.2179565,0.3207092-0.5085754,0.3113861-0.8095856
		l-0.9964142-28.677887c3.9638367,0.0415192,7.9816437,0.1349335,12.0191803,0.2895966
		c0.1764526,5.2010345,0.3311005,10.4217987,0.4452667,15.6010437c0.1349335,5.8539124,0.2283478,11.2407532,0.2916565,16.4718781
		c0.1764526,16.8455505,0.4982147,67.4340515,0.7877808,112.0648499c0.2698669,42.4615479,0.5096283,79.1314697,0.5822906,83.335083
		c0.1764374,8.8119812-0.35289,62.1302185-0.85112,67.5378113c-0.0207367,0.1027832-0.3331604,2.2107849,0.6539001,3.4874573
		C228.6912842,463.7120667,226.1992188,463.4318237,226.1587372,463.4318237 M255.3140717,463.8158569
		c-5.885025,1.4012146-22.3153992,0.8303528-23.8006744,0c-1.4416809-0.7991943-1.0379181-3.4043884-1.0379181-3.4562988
		c0.509613-5.4387207,1.0379181-58.8192444,0.8614807-67.6312256c-0.0830383-4.2036133-0.3207245-42.6380005-0.5802155-83.335083
		c-0.2906189-44.6307983-0.6123657-95.2089233-0.7888184-112.0544739c-0.0622711-5.2415161-0.1557007-10.6283569-0.2802429-16.49263
		c-0.3009949-13.1712799-0.8303375-26.5501251-1.3295746-39.4930573l-0.2376862-6.1040649
		c-0.4369659-11.0736313-0.3746948-21.1830215-0.3010101-31.8944244l0.0197449-3.3005905
		c1.3607025-1.0586777,2.7100067-2.0343246,4.0167542-2.9165726c2.5335846-0.3010101,5.8653259-0.4670792,7.9930573-0.4982147
		h0.3622437c0.3529053-0.0103607,0.7057953-0.0103607,1.0597229-0.0103607
		c2.0343323,0.0103607,4.1101837,0.1037674,6.1123505,0.1764297c1.3503418,0.0622787,2.6882172,0.1141891,4.0385742,0.1453247
		c0.8303375,0.020752,1.2766418,0.0414963,2.1993713,0.1660767c0.0217896,0.0103531,0.0311279,0.0207443,0.0425415,0.0311356
		c0,0.1972046,0,0.7680511,0.0508575,2.3456879c0.1359711,3.4355316,0.1255951,10.0668488,0.1255951,14.0431366v1.3181839
		c0.0508575,2.698616,0.1037903,5.3972015,0.1650238,8.0958099c0.0321655,1.5361404,0.0737,2.3249435,0.1048279,3.1241684
		c0.0404816,0.7680588,0.0726624,1.5465012,0.1027527,3.0099792c0.0840759,3.2071838,0.1567383,6.4040222,0.2397614,9.6008148
		c0.0830383,3.2798462,0.1660767,6.5493011,0.259491,9.8187714l0.4463043,16.0774841h-0.020752l0.020752,0.6746521h0.0197296
		l0.7680511,27.806015l-0.1027527,266.7677002C255.8434143,459.8509827,256.2990723,462.0410156,255.3140717,463.8158569
		 M364.0368042,442.5383911c-0.7265625,0.3321228-1.473877,0.6850281-2.2315674,1.0483093
		c-6.0510864,2.8335266-12.9013977,6.0510864-19.980072,7.6391296l0.0726624,0.3217468l-0.1047974-0.3113708
		c-5.1678467,1.7125854-10.0876465,2.875061-14.2092285,3.7884216c-7.7522888,1.7022095-15.8283691,2.4173279-23.6335754,3.1137695
		c-2.9674072,0.2698669-6.0407104,0.5397339-9.0403137,0.8604431l-33.9702759,3.654541
		c-1.2673035,0.2377014-3.5808411,0.6435242-4.7132263,0.7784424c0.6653137-1.8059998,0.2916565-3.6430969,0.2802429-3.6742554
		l0.1152039-266.7053833l-0.7680664-27.8164368c3.840332-0.134903,7.6702881-0.2293549,11.4680481-0.2698364l-0.1349182,29.6016388
		c0,0.3010101,0.1152039,0.5916138,0.3331604,0.8095703c0.2377014,0.238739,0.5708618,0.3840332,0.9227295,0.3840332
		l75.5921021,0.2802277h0.010376c0.6643066,0,1.2257996-0.5189667,1.2362061-1.1520844l0.6019592-25.2215881
		c4.6810608,0.591629,8.1373596,1.0898132,10.1197815,1.3897705c-0.7586975,8.107254-1.3607178,16.7220154-1.4842224,25.3575745
		l-0.0114136,1.1313324c-0.1245728,7.9505157-0.2376709,16.1708679,1.8900452,23.7996368
		c2.3561096,8.4487305,5.4802551,15.0084229,9.8187866,20.6339722c1.3700562,1.7956238,2.1059875,4.0271454,2.0758362,6.2898254
		c-0.2179565,14.0639038-0.8521118,60.7290344,0.0622864,70.9111023c1.0587158,11.8427124,0.010376,90.9638062,0,91.7733765
		c0,0.3632813,0.1650391,8.9884644,1.3482666,11.1162109c0.249115,0.4462891,0.6653137,1.8163757,1.214386,5.7905884
		C371.7278137,433.6641235,367.8148499,440.7843018,364.0368042,442.5383911"
        />
        <path
          fill="#010101"
          d="M211.046524,326.3422852c-39.8251953-0.9860535-56.3282318-3.7469177-65.1931458-5.2311401
		c-0.7358856-0.1245728-1.4105377-0.228363-2.0332947-0.3321533c-3.9347687-0.6331482-11.4701233-2.2730713-11.5531616-2.2927856
		l-5.0328979-0.8936462c-0.2293777-0.0415344-0.4680939,0.020752-0.6538849,0.1764526
		c-0.176445,0.1556702-0.2812805,0.3746643-0.2812805,0.6123657v28.3457642c0,0.5500793,0.2916565,1.0690613,0.7680664,1.3503418
		c0.5511398,0.3207092,1.0078125,0.5802002,1.4323425,0.7981567h-0.2179718l0.509613,69.3448486v0.1764526l0.1442719,0.1027527
		c2.5335846,1.755127,5.3141937,3.1968079,8.2619019,4.2980652c2.9902649,1.1095276,5.9275818,1.6907654,9.1648865,2.2720032
		c6.6634827,1.1946716,13.4317932,2.2004089,20.1160278,3.0110168c11.1151581,1.3378906,22.4389191,2.428772,33.4004517,3.4760132
		c3.0722504,0.3010254,6.1445313,0.5926819,9.2167816,0.8936768c0.0518951,0.0093384,0.1027527,0.0093384,0.1442719,0.0093384
		c0.3632813,0,0.7172089-0.1338806,0.9870758-0.3840332c0.3009949-0.2688293,0.4774323-0.6632385,0.4774323-1.0690613v-73.2983093
		h0.2075806c0.3113861,0,0.6123962-0.1131287,0.8303528-0.3311157c0.2273102-0.2283325,0.3518524-0.530365,0.3518524-0.8417664
		v-29.1138C212.0937958,326.8415222,211.6277618,326.3640747,211.046524,326.3422852 M210.0283203,431.0067139
		c0,0.2179565-0.0934143,0.4255371-0.2594757,0.5708618c-0.1660614,0.1452942-0.3726044,0.2189941-0.602005,0.1972046
		c-3.0712128-0.3009949-6.154892-0.5916138-9.2271576-0.8926392c-10.9490814-1.0482788-22.27388-2.1381226-33.3796844-3.4770508
		c-6.672821-0.7981567-13.429718-1.8163452-20.0734863-2.9985657c-3.2165222-0.5822754-6.1123352-1.1427307-9.0496674-2.2429504
		c-2.8449554-1.0586853-5.5228119-2.4494934-7.9712677-4.1195068l-0.4982147-68.9286499
		c0.6943817,0.3518372,1.3482666,0.6320801,2.1786194,0.9849854c3.3836212,1.4530945,7.0993958,2.8968506,11.2511139,3.5704651
		c11.334137,1.8267212,34.0865173,3.1760559,67.6312256,4.0167542V431.0067139z M211.4191589,356.5355225
		c0,0.1349487-0.0508728,0.259491-0.1453247,0.3539429c-0.1027527,0.0934143-0.2376709,0.1442871-0.373642,0.1442871
		c-33.9806519-0.8293152-56.9914703-2.190033-68.3982697-4.036499c-4.0800934-0.6549377-7.7429352-2.0758667-11.0964661-3.5196228
		c-1.4738617-0.6217041-2.3550568-1.0067749-3.9949875-1.9824219c-0.2698517-0.1660767-0.4359207-0.455658-0.4359207-0.7680664
		v-28.3457642c0-0.0519104,0.030098-0.0830383,0.0415192-0.0934143c0.020752-0.0093384,0.0415115-0.0311279,0.0830307-0.0311279
		h0.019722l5.0131836,0.8926086c0.0736847,0.010376,7.6297913,1.6502991,11.5842896,2.2938232
		c0.622757,0.1037903,1.2973938,0.2179565,2.0332947,0.3331604c8.8742676,1.4832153,25.3990784,4.2544556,65.2761841,5.2415466
		c0.2169189,0.0093384,0.3933868,0.1857605,0.3933868,0.4037476V356.5355225z"
        />
        <path
          fill="#010101"
          d="M359.3660278,317.7698364c-0.1764526-0.1567078-0.4151611-0.2179565-0.6445313-0.1764526
		l-5.0433044,0.8926086c-0.0737,0.0207825-7.6080017,1.6607056-11.5417175,2.2927856
		c-0.6227722,0.1048584-1.3078003,0.2076111-2.0343628,0.3321533c-8.8638611,1.4842224-25.3565063,4.2451172-65.1931152,5.2311401
		c-0.5812378,0.0217896-1.0587158,0.4992371-1.0587158,1.0794373v29.1138306c0,0.3113708,0.1349487,0.6134033,0.3632813,0.8417358
		c0.2190247,0.2179871,0.5189819,0.3311157,0.8313904,0.3311157h0.206543v73.2983093
		c0,0.4058228,0.1764526,0.8002319,0.4784851,1.0690613c0.2698669,0.2501526,0.6227417,0.3850708,0.9849854,0.3850708
		c0.0425415,0,0.0934143,0,0.1359863-0.010376c3.0826416-0.3009949,6.1548767-0.5916138,9.2271423-0.8936462
		c10.9594727-1.0472717,22.2832336-2.1381226,33.3993835-3.4760132c6.6853027-0.8096008,13.4515381-1.8163757,20.1150208-3.0110168
		c3.2383118-0.5812378,6.1663208-1.1624756,9.1648865-2.2720337c2.9477234-1.1012268,5.7304077-2.5429077,8.2619019-4.2980347
		l0.1453247-0.1027527l0.4981689-69.5213318h-0.206543c0.4244995-0.2179565,0.8822327-0.4774475,1.4313049-0.7981567
		c0.4670715-0.2812805,0.7680664-0.8002319,0.7680664-1.3503418v-28.3457642
		C359.6556091,318.1434937,359.5528564,317.9244995,359.3660278,317.7698364 M356.4909668,418.0438538
		c-2.450531,1.6700134-5.1283875,3.0608521-7.9712524,4.120575c-2.9373474,1.0991516-5.8331299,1.6596375-9.0507202,2.2419128
		c-6.6427307,1.1821899-13.3996277,2.2004089-20.0745239,2.9985657
		c-11.1058044,1.3399658-22.4295654,2.4287415-33.3786621,3.4770508c-3.0733032,0.3009949-6.1548767,0.5916138-9.2271423,0.8926086
		c-0.2086182,0.0217896-0.4359436-0.0508423-0.6030273-0.1972046c-0.1660767-0.1452942-0.259491-0.3528748-0.259491-0.5708618
		v-73.3180237c33.536438-0.8417664,56.2981262-2.1910706,67.6322937-4.0178223
		c4.1517029-0.6736145,7.8674622-2.1173706,11.250061-3.5704651c0.8313599-0.3529053,1.4842224-0.6320801,2.179657-0.9849854
		L356.4909668,418.0438538z M358.9809875,346.7269287c0,0.312439-0.1650696,0.6019897-0.4463501,0.7680664
		c-1.6295166,0.9767151-2.5210876,1.3607178-3.9949646,1.9824524c-3.3431396,1.4437256-7.006012,2.8646545-11.0954285,3.5195923
		c-11.3964233,1.8464661-34.4072266,3.2072144-68.388916,4.0375366c-0.1245422,0-0.2698669-0.0518799-0.3736572-0.1453247
		c-0.0944519-0.0944214-0.1557007-0.2189941-0.1557007-0.3539124v-29.1138306c0-0.2179565,0.1868286-0.3933716,0.4048157-0.4037476
		c39.8760376-0.9860229,56.3998413-3.7572937,65.2740784-5.2415161c0.7379761-0.1141663,1.4126587-0.2294006,2.0353699-0.3321533
		c3.9545288-0.6434937,11.5002441-2.2844849,11.5625-2.2938232l5.0329285-0.8936462h0.0217896
		c0.0415039,0,0.0612183,0.0217896,0.0830383,0.032196c0.010376,0.0093079,0.0404968,0.0415039,0.0404968,0.0923462V346.7269287z"
        />
      </g>
    </svg>
  );
}
